<template>
  <div>    
    <b-modal id="loading-modal" :visible="isLoading" centered hide-footer  title="Processando Aguarde...">
      <div class="text-center">
        <img src="@/assets/aguarde_2.gif" alt="Loading">        
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    mostrarModal() {
      this.isLoading = true; // Defina isLoading como true para mostrar o modal
    },
  },
  created() {
    // Exemplo: Chame a função mostrarModal após um atraso de 2 segundos
      this.mostrarModal();
  },
};
</script>
